import React, {useState, useEffect, useRef} from "react";
import axios from "axios";
import {base, projects_url, volunteers} from "../../api";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {Link} from "react-router-dom";
import {FiArrowLeft} from "react-icons/fi";
import {AutoComplete} from "primereact/autocomplete";
import {Skeleton} from "primereact/skeleton";
import {Toast} from "primereact/toast";
import {useParams} from "react-router-dom";

export default function VolunteersForm(props) {
	const [selectedProject, setSelectetProject] = useState();
	const [filteredProject, setFilteredProject] = useState();
	const [ongoingProjects, setOngoingProjects] = useState([]);
	const [complatedProjects, setComplatedProjects] = useState([]);
	const [allProjects, setAllProjects] = useState([]);

	const toast = useRef(null);

	const clearFields = () => {
		[
			"full_name",
			"phone_number",
			"email",
			"accept_date",
			"birth_certificate",
			"address",
			"authorized_person_name",
			"authorized_person_id",
			"authorized_person_phone",
			"authorized_person_email",
			"authorized_person_address",
		].forEach(id => {
			const el = document.getElementById(id);
			if (el) el.value = "";
		});
		document.querySelectorAll('input[name="flexRadioDefault"]').forEach(r => (r.checked = false));
	};

	const {id} = useParams();
	useEffect(() => {
		loadData();
		console.log(id);

		if (id) {
			axios.get(base + volunteers + id + "/").then(res => {
				const data = res.data;
				setSelectetProject(data.project || null);
				document.getElementById("full_name").value = data.full_name || "";
				document.getElementById("phone_number").value = data.phone_number || "";
				document.getElementById("email").value = data.email || "";
				document.getElementById("accept_date").value = data.birth_date || "";
				document.getElementById("birth_certificate").value = data.birth_certificate || "";
				document.getElementById("address").value = data.address || "";
				if (data.gender === "male") {
					document.getElementById("flexRadioDefault1").checked = true;
				} else if (data.gender === "female") {
					document.getElementById("flexRadioDefault2").checked = true;
				}
				document.getElementById("authorized_person_name").value = data.authorized_person_name || "";
				document.getElementById("authorized_person_id").value = data.authorized_person_id || "";
				document.getElementById("authorized_person_phone").value =
					data.authorized_person_phone || "";
				document.getElementById("authorized_person_email").value =
					data.authorized_person_email || "";
				document.getElementById("authorized_person_address").value =
					data.authorized_person_address || "";
			});
		}
	}, []);

	function loadData() {
		axios.get(base + projects_url).then(res => {
			setComplatedProjects(
				res.data.sort((a, b) => b.id - a.id).filter(item => item.completed == false),
			);
			setOngoingProjects(
				res.data.sort((a, b) => b.id - a.id).filter(item => item.completed == true),
			);
			setAllProjects(res.data.sort((a, b) => b.id - a.id));
		});
	}

	const search = event => {
		let query = event.query;
		let _filteredPartner = allProjects?.filter(
			item => item?.full_name_am?.toLowerCase().indexOf(query?.toLowerCase()) !== -1,
		);
		setFilteredProject(_filteredPartner);
	};

	// handleSubmit function
	const handleSubmit = async () => {
		try {
			const payload = {
				project_id: selectedProject?.id ?? null,
				full_name: document.getElementById("full_name").value,
				phone_number: document.getElementById("phone_number").value,
				email: document.getElementById("email").value,
				birth_date: new Date(document.getElementById("accept_date").value)
					.toISOString()
					.slice(0, 10),
				birth_certificate: document.getElementById("birth_certificate").value,
				address: document.getElementById("address").value,
				gender:
					document.querySelector('input[name="flexRadioDefault"]:checked')?.id ===
					"flexRadioDefault1"
						? "male"
						: "female",
				authorized_person_name: document.getElementById("authorized_person_name").value,
				authorized_person_id: document.getElementById("authorized_person_id").value,
				authorized_person_phone: document.getElementById("authorized_person_phone").value,
				authorized_person_email: document.getElementById("authorized_person_email").value,
				authorized_person_address: document.getElementById("authorized_person_address").value,
			};
			await axios.post(base + volunteers, payload);
			toast.current.show({
				severity: "success",
				summary: "Success",
				detail: "Volunteer created successfully",
				life: 3000,
			});
			clearFields();
		} catch (err) {
			console.error("Submission failed", err);
		}
	};

	return (
		<div className="col-12 p-0">
			<Toast ref={toast} />
			<div className="card border-0 w-100 b-radius b-shadow p-3 mb-4">
				<div className="row p-3">
					<div className="d-flex justify-content-between align-items-center my-3">
						<div className="fs-5">Կամավորի տվյալներ</div>
						<Link to="/volunteers" className="btn btn-outline-secondary">
							<FiArrowLeft className="me-2" />
							գնալ նախորդ էջ
						</Link>
					</div>
					<hr />
					<div className="flex flex-column col-lg-8 col-md-6 col-12 ">
						<label htmlFor="full_name">Ծրագիր</label>
						{allProjects ? (
							<AutoComplete
								dropdown
								className="py-3"
								placeholder="Ընտրել ծրագիրը"
								field={"full_name_am"}
								completeMethod={search}
								suggestions={filteredProject}
								value={selectedProject}
								onChange={e => setSelectetProject(e.value)}
								itemTemplate={item => (
									<div className="d-flex align-items-top">
										<div className="d-grid">
											<span className="text-primary">{item?.full_name_am.substring(0, 75)} </span>
											<span className="text-secondary small">{item?.name ?? "not provided"}</span>
											<span className="text-secondary small">
												{item?.name_en ?? "not provided"}
											</span>
										</div>
									</div>
								)}
							/>
						) : (
							<Skeleton width="100%" height="55px"></Skeleton>
						)}
					</div>
					<div className="flex flex-column col-lg-4 col-md-6 col-12 gap-2">
						<label htmlFor="full_name">Անուն ազգանուն</label>
						<InputText id="full_name" className="py-3" />
					</div>
					<div className="flex flex-column col-lg-4 col-md-6 col-12 gap-2">
						<label htmlFor="phone_number">Հեռախոսահամար</label>
						<InputText id="phone_number" className="py-3" />
					</div>
					<div className="flex flex-column col-lg-4 col-md-6 col-12 gap-2">
						<label htmlFor="email">Էլ. հասցե</label>
						<InputText id="email" className="py-3" />
					</div>

					<div className="flex flex-column col-lg-4 col-md-6 col-12 gap-2">
						<label htmlFor="accept_date">Ծննդյան օր / տարեթիվ</label>
						<input
							type="date"
							id="accept_date"
							className="form-control py-3"
							dateFormat="dd/mm/yy"
						/>
					</div>
					<div className="flex flex-column col-lg-4 col-md-6 col-12 gap-2">
						<label htmlFor="birth_certificate">Ծննդյան վկայական</label>
						<InputText id="birth_certificate" className="py-3" />
					</div>
					<div className="flex flex-column col-lg-8 gap-2 mt-2">
						<label htmlFor="address">Հասցե</label>
						<InputText id="address" className="py-3" />
					</div>
					<div className="flex flex-column col-lg-4 col-md-6 col-12 gap-2">
						<label htmlFor="gender">Սեռ</label>
						<div className="d-flex align-items-center py-3">
							<div class="form-check me-3">
								<input
									class="form-check-input"
									type="radio"
									name="flexRadioDefault"
									id="flexRadioDefault1"
								/>
								<label class="form-check-label" for="flexRadioDefault1">
									Արական
								</label>
							</div>
							<div class="form-check ms-3">
								<input
									class="form-check-input"
									type="radio"
									name="flexRadioDefault"
									id="flexRadioDefault2"
								/>
								<label class="form-check-label" for="flexRadioDefault2">
									Իգական
								</label>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="card border-0 w-100 b-radius b-shadow p-3 mt-4">
				<div className="row p-3">
					<div className="fs-5 my-3">Լիազոր անձ</div>
					<hr />
					<div className="flex flex-column col-lg-4 col-md-6 col-12 gap-2">
						<label htmlFor="authorized_person_name">Ծնողի կամ լիազորված անձի անուն ազգանուն</label>
						<InputText id="authorized_person_name" className="py-3" />
					</div>
					<div className="flex flex-column col-lg-4 col-md-6 col-12 gap-2">
						<label htmlFor="authorized_person_id">Անձնագիր կամ նույնականացման քարտ</label>
						<InputText id="authorized_person_id" className="py-3" />
					</div>
					<div className="flex flex-column col-lg-4 col-md-6 col-12 gap-2">
						<label htmlFor="authorized_person_phone">Հեռախոսահամար</label>
						<InputText id="authorized_person_phone" className="py-3" />
					</div>
					<div className="flex flex-column col-lg-4 col-md-6 col-12 gap-2">
						<label htmlFor="authorized_person_email">Էլ. հասցե</label>
						<InputText id="authorized_person_email" className="py-3" />
					</div>
					<div className="flex flex-column col-8 gap-2">
						<label htmlFor="authorized_person_address">Հասցե</label>
						<InputText id="authorized_person_address" className="py-3" />
					</div>
				</div>
			</div>
			<div className="card border-0 w-100 b-radius b-shadow p-3 mt-4">
				<div className="d-flex aling-items-center justify-content-center">
					<Link
						to={"/volunteers"}
						className="btn btn-outline-secondary d-flex align-items-center me-3">
						<FiArrowLeft className="me-2" />
						Cancel
					</Link>
					<Button
						label={"Save"}
						icon={"pi pi-save"}
						className="btn btn-primary"
						onClick={handleSubmit}
					/>
				</div>
			</div>
		</div>
	);
}
